import React from 'react';
import { Section, Eyebrow } from '../Section';
const stats = [{
  value: '4.9/5',
  label: 'Average rating'
}, {
  value: '+300',
  label: 'Professional resources'
}, {
  value: '+2,000',
  label: 'Technicians'
}, {
  value: '99%',
  label: 'Would recommend it'
}];
export function SocialProof() {
  return <Section tone="dark" data-id="element-248" data-mp="8ee1gan879ez">
      <Eyebrow data-id="element-249" data-mp="8d2yue5io7pg">⭐ Join 2,000+ technicians</Eyebrow>
      <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-250" data-mp="3e9lqmu56ipt">
        More than 2,000 appliance repair technicians are already using Technical
        System PRO 360™ to organize their businesses and save hours of
        administrative work.
      </p>

      <dl className="mt-7 grid grid-cols-2 gap-3" data-id="element-251" data-mp="3lke66o85q3dr">
        {stats.map(stat => <div key={stat.label} className="rounded-xl border border-white/10 bg-navy-950 px-3 py-4 text-center" data-id="element-252" data-mp="1orugbw14jujz">
            <dt className="sr-only" data-id="element-253" data-mp="1ju2r59rv6mjh">{stat.label}</dt>
            <dd data-id="element-254" data-mp="1t8ilihumw3v0">
              <span className="block font-display text-[32px] font-extrabold leading-none text-gold-500 sm:text-4xl" data-id="element-255" data-mp="1t80qtpnmdxp7">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[11px] font-bold uppercase tracking-[0.08em] text-white/60 sm:text-xs" data-id="element-256" data-mp="1y591742j0xfw">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </Section>;
}